/** Maximum items in a single equipment batch request */
export const MAX_BATCH_ARRAY_SIZE = 100;
